import { FieldErrors } from 'react-hook-form'
import get from 'lodash/get'
import { TRateConfirmationFormSchema } from '../schema/RateConfirmationFormSchema'

export const getErrorMessage = <
  T extends FieldErrors<TRateConfirmationFormSchema>,
  K extends keyof T
>(
  errors: T,
  keyName: K
): string | undefined => {
  return get(errors, [keyName, 'message'])
}
